export const RBO_FORMAT_VALIDATION_DONT_SHOW_FLAG = 'rbo-format-validation-dont-show';
export const AMAZON_MARKETPLACE_DONT_SHOW_FLAG = 'amazon-marketplace-confirmation-dont-show';
